var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { isVNode } from "vue";
import { isObject, isArray, isFunction } from "../../_utils/is.js";
import { isNamedComponent, isSlotsChildren, isArrayChildren, resolveProps, getVNodeChildrenString, getChildrenFunc, getBooleanProp } from "../../_utils/vue-utils.js";
const isGroupOption = (option) => {
  return isObject(option) && "isGroup" in option;
};
const getOptionNodes = ({
  children,
  options,
  extraOptions,
  inputValue,
  filterOption,
  optionInfoMap,
  enabledOptionSet
}) => {
  const nodes = [];
  const getAndSaveOptionInfo = (option, origin) => {
    var _a, _b, _c, _d;
    const index = optionInfoMap.size;
    let optionInfo;
    if (isVNode(option)) {
      const props = resolveProps(option);
      const label = (_a = props.label) != null ? _a : getVNodeChildrenString(option);
      const value = (_b = props.value) != null ? _b : label;
      const render = getChildrenFunc(option);
      const key = `option-${typeof value}-${value}`;
      optionInfo = __spreadProps(__spreadValues({}, props), {
        index,
        key,
        value,
        label,
        render,
        disabled: getBooleanProp((_c = option.props) == null ? void 0 : _c.disabled),
        origin: "children"
      });
    } else {
      optionInfo = isObject(option) ? __spreadProps(__spreadValues({}, option), {
        index,
        key: `option-${typeof option.value}-${option.value}`,
        value: option.value,
        label: (_d = option.label) != null ? _d : String(option.value),
        disabled: Boolean(option.disabled),
        origin
      }) : {
        index,
        key: `option-${typeof option}-${option}`,
        value: option,
        label: String(option),
        disabled: false,
        origin
      };
    }
    if (optionInfoMap.get(optionInfo.value)) {
      return void 0;
    }
    optionInfoMap.set(optionInfo.value, optionInfo);
    return optionInfo;
  };
  const isValidOption = (optionInfo) => {
    if (isFunction(filterOption)) {
      return !inputValue || filterOption(inputValue, optionInfo);
    }
    if (filterOption) {
      return optionInfo.label.toLowerCase().includes((inputValue != null ? inputValue : "").toLowerCase());
    }
    return true;
  };
  const extendChildrenFromOptions = (options2, origin) => {
    for (const item of options2) {
      if (isGroupOption(item)) {
        if (isArray(item.options) && item.options.length > 0) {
          nodes.push({
            type: "optGroup",
            key: `group-${item.label}`,
            label: item.label
          });
          extendChildrenFromOptions(item.options, origin);
        }
      } else {
        const optionInfo = getAndSaveOptionInfo(item, origin);
        if (optionInfo && isValidOption(optionInfo)) {
          nodes.push({
            type: "option",
            key: optionInfo.key,
            value: optionInfo.value,
            label: optionInfo.label,
            render: optionInfo.render,
            disabled: optionInfo.disabled
          });
          if (!optionInfo.disabled) {
            enabledOptionSet.add(optionInfo.value);
          }
        }
      }
    }
  };
  const travelChildren = (children2) => {
    var _a, _b, _c, _d, _e;
    for (const child of children2) {
      if (isNamedComponent(child, "Optgroup")) {
        nodes.push({
          type: "optGroup",
          key: `group-${(_a = child.props) == null ? void 0 : _a.label}`,
          label: (_b = child.props) == null ? void 0 : _b.label
        });
        if (isSlotsChildren(child, child.children)) {
          const _children = (_e = (_d = (_c = child.children).default) == null ? void 0 : _d.call(_c)) != null ? _e : [];
          travelChildren(_children);
        } else if (isArrayChildren(child, child.children)) {
          travelChildren(child.children);
        }
      } else if (isNamedComponent(child, "Option")) {
        const optionInfo = getAndSaveOptionInfo(child, "children");
        if (optionInfo && isValidOption(optionInfo)) {
          nodes.push({
            type: "option",
            key: optionInfo.key,
            value: optionInfo.value,
            label: optionInfo.label,
            render: optionInfo.render,
            disabled: optionInfo.disabled
          });
          if (!optionInfo.disabled) {
            enabledOptionSet.add(optionInfo.value);
          }
        }
      } else if (isArrayChildren(child, child.children)) {
        travelChildren(child.children);
      }
    }
  };
  if (children) {
    travelChildren(children);
  } else if (options) {
    extendChildrenFromOptions(options, "options");
  }
  if (extraOptions) {
    extendChildrenFromOptions(extraOptions, "extraOptions");
  }
  return nodes;
};
export { getOptionNodes };
